import clsx from 'clsx';
import { Layout } from '../../components/Common/Layout';
import { Button } from 'ui/mobile-ds';
import { useNavigate } from 'react-router-dom';
import { getLogoPath } from '../../utils/getLogoMap';
import { useRelationContext } from '../../context/RelationContext';
import { CheckCircle } from 'ui/icons';
import { useEffect } from 'react';

const RequestCreated = () => {
  const { relationData, setRelationData } = useRelationContext();
  const navigate = useNavigate();
  useEffect(() => {
    if (!relationData) {
      navigate('/family-addition/add-family-member');
    }
  }, []);
  const okayGotItHandleClick = () => {
    setRelationData({});
    navigate('/family-addition/add-family-member');
  };
  return (
    <>
      <Layout.Main
        fullWidth
        hideFooter
        rootClassName="gap-3"
        containerProps={{
          className: clsx({
            'h-full max-h-full !m-0 justify-center flex px-5': true,
          }),
        }}
        className="p-0"
        headerProps={{
          hidePageHeader: true,
          sticky: true,
        }}
      >
        <div className="flex items-center justify-center flex-col gap-6">
          <div>
            <img
              src={getLogoPath(
                relationData?.relationship,
                relationData?.gender
              )}
              height={100}
              width={100}
            />
            <CheckCircle
              className="relative bottom-5 left-16"
              height={24}
              width={24}
              stroke="#BFF3EA"
              fill="#4E9594"
              color="white"
              pathStroke="#FFFFFF"
            />
          </div>
          <p className="text-2xl text-gray-600 font-chromatica font-black">
            Request Created
          </p>
          <p className="w-full md:w-[60%] text-center text-sm text-gray-600">
            Your request to add a new dependent has been created. You will be
            notified when the dependent has been added successfully.
          </p>
          <Button
            onClick={okayGotItHandleClick}
            className="w-full md:w-[25%] p-3 text-lg"
          >
            Okay, Got it
          </Button>
        </div>
      </Layout.Main>
    </>
  );
};

export default RequestCreated;
